module.exports = __webpack_public_path__ + "img/appAsset-flag--CO.8f7ed334.svg";